import { action, makeObservable, observable } from 'mobx';

export class SpinnerStore {
  @observable public spinnerCache: Map<string, boolean> = new Map();

  constructor() {
    makeObservable(this);
  }


  isVisible = (name: string) => {
    return this.spinnerCache.get(name);
  }

  @action
  show = (spinnerName: string) => {
    this.spinnerCache.set(spinnerName, true);
  }

  @action
  hide = (spinnerName: string) => {
    this.spinnerCache.set(spinnerName, false);
  }
}

export default SpinnerStore;